<template>
  <div>
    <template v-if="item.article_id">
      <el-menu-item
        @click="handleClickMenu(item)"
        style="color: rgb(0, 73, 176)"
      >
        <span>{{ item.article_title }}</span>
      </el-menu-item>
    </template>
    <template v-else-if="item.customMenuItem">
      <el-menu-item
        @click="handleClickCustomMenu(item)"
        style="color: rgb(0, 73, 176)"
      >
        <span>{{ item.column_name }}</span>
      </el-menu-item>
    </template>
    <template v-else>
      <el-submenu :index="item.article_id || item.column_id">
        <template slot="title">
          <span>{{ item.column_name }}</span>
        </template>
        <template
          v-if="
            [
              ...(item.child ? item.child : []),
              ...(item.children ? item.children : []),
            ].length
          "
        >
          <template
            v-for="(v, i) of [
              ...(item.child ? item.child : []),
              ...(item.children ? item.children : []),
            ]"
          >
            <navigation-item :key="i" :item="v"></navigation-item>
          </template>
        </template>
      </el-submenu>
    </template>
  </div>
</template>

<script>
import { bus } from "@/main";

export default {
  name: "navigationItem",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    handleClickMenu(data) {
      console.log(data);
      bus.$emit("menuClick", data);
    },
    handleClickCustomMenu(data) {
      bus.$emit("customMenuClick", data);
    },
  },
  computed: {},
  mounted() {},
  created() {},
};
</script>
